import { MapTo } from '@adobe/aem-react-editable-components';
import spreadModelProps from 'helpers/spreadModelProps';
import StoreFinder from './StoreFinder';

const StoreFinderEditableConfig = {
  emptyLabel: 'Store Finder Component',
  isEmpty: (props) => !props,
};
export default MapTo('aweb/components/content/store-finder')(spreadModelProps(StoreFinder), StoreFinderEditableConfig);
